import { render, staticRenderFns } from "./PhotostylePage.vue?vue&type=template&id=4ec9dfe4&scoped=true&"
import script from "./PhotostylePage.vue?vue&type=script&lang=js&"
export * from "./PhotostylePage.vue?vue&type=script&lang=js&"
import style0 from "./PhotostylePage.vue?vue&type=style&index=0&id=4ec9dfe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec9dfe4",
  null
  
)

export default component.exports